export default __webpack_public_path__ + "static/media/appleSmall.baf619e5.svg";